import { useEffect } from 'react';

/** Зона старта жеста у левого края экрана, px */
const EDGE_WIDTH = 30;
/** Минимальная горизонтальная длина свайпа, px */
const MIN_DISTANCE = 70;
/** Максимальная длительность жеста, мс */
const MAX_DURATION = 700;
/** Во сколько раз горизонтальное смещение должно превышать вертикальное */
const HORIZONTAL_RATIO = 2;

/**
 * iOS-подобный жест «назад»: свайп вправо от левого края экрана.
 *
 * Элементы с собственными горизонтальными жестами (карта, карусели)
 * исключаются атрибутом data-no-swipe-back на контейнере.
 */
export function useSwipeBack(goBack: () => void, enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    let tracking = false;
    let startX = 0;
    let startY = 0;
    let startTime = 0;

    const onTouchStart = (e: TouchEvent) => {
      if (e.touches.length !== 1) return;

      const touch = e.touches[0];
      if (touch.clientX > EDGE_WIDTH) return;

      const target = e.target as Element | null;
      if (target?.closest?.('[data-no-swipe-back]')) return;

      tracking = true;
      startX = touch.clientX;
      startY = touch.clientY;
      startTime = Date.now();
    };

    const onTouchEnd = (e: TouchEvent) => {
      if (!tracking) return;
      tracking = false;

      const touch = e.changedTouches[0];
      const dx = touch.clientX - startX;
      const dy = Math.abs(touch.clientY - startY);
      const dt = Date.now() - startTime;

      if (
        dx >= MIN_DISTANCE &&
        dx > dy * HORIZONTAL_RATIO &&
        dt <= MAX_DURATION
      ) {
        goBack();
      }
    };

    const onTouchCancel = () => {
      tracking = false;
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('touchcancel', onTouchCancel, { passive: true });

    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchend', onTouchEnd);
      document.removeEventListener('touchcancel', onTouchCancel);
    };
  }, [goBack, enabled]);
}
